import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-documentos',
  templateUrl: './documentos.component.html'
})
export class DocumentosComponent implements OnInit {
  data = [
    {
      titulo : 'ORDENANZA FISCAL REGULADORA DE LA TASA DE DEPURACIÓN DE AGUAS',
      descripcion : 'El objeto del Reglamento es establecer las relaciones existentes entre el Servicio Municipal de Aguas y sus usuarios.'
    },
    {
      titulo : 'ORDENANZA FISCAL REGULADORA DE LA TASA POR DISTRIBUCIÓN DE AGUA',
      descripcion : 'Regula la Tasa por Distribución de Agua.'
    },
    {
      titulo : 'REGLAMENTO DEL SERVICIO MUNICIPAL DE AGUAS POTABLES DE MELILLA',
      descripcion : 'El objeto del Reglamento es establecer las relaciones existentes entre el Servicio Municipal de Aguas y sus usuarios.'
    }
  ];

  constructor() { }

  ngOnInit() { }

  downloadFile(solId: number) {
    const link = document.createElement('a');
    switch (solId) {
      case 0:
        link.download = 'ORDENANZA_FISCAL_REGULADORA_DE_LA_TASA_DE_DEPURACION_DE_AGUAS';
        link.href = 'assets/documents/ORDENANZAFISCALREGULADORADELATASADEDEPURACIONDEAGUAS.pdf';
      break;
      case 1:
        link.download = 'ORDENANZA_FISCAL_REGULADORA_DE_LA_TASA_POR_DISTRIBUCION_DE_AGUA';
        link.href = 'assets/documents/ORDENANZAFISCALREGULADORADELATASAPORDISTRIBUCIONDEAGUA.pdf';
      break;
      case 2:
        link.download = 'REGLAMENTO_DEL_SERVICIO_MUNICIPAL_DE_AGUAS_POTABLES_DE_MELILLA';
        link.href = 'assets/documents/REGLAMENTODELSERVICIOMUNICIPALDEAGUASPOTABLESDEMELILLA.pdf';
      break;
    }
    link.click();
  }

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/documentos.component.ts